import { Product } from './Product';

/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
export class InvoiceDetail {

    product: Product;
    subtotal: number = 0.00; //Sin Iva
    importeTotal: number = 0.00; //Con Iva
    iva0Total: number = 0.00;
    iva12Total: number = 0.00;
    aplicarIva12: boolean = false;
    amount: number = 0.00; //Cantidad de productos
    price: number = 0.00; //Precio personalizado por cada factura, sino toma el mismo del producto
    discount: number = 0.00; //Descuento personalizado
    taxType:string;
    taxFactor:number;
    
    //Auxiliares de vista
    productId:number;
    productName: string;
    productPrice: number;
}